import React, { useState } from "react";

const ContactModal = () => {
  const [isOpen, setIsOpen] = useState(false);

  const openModal = () => setIsOpen(true);
  const closeModal = () => setIsOpen(false);

  return (
    <>
      {/* Button to Open Modal */}
      <button
        onClick={openModal}
        className=" text-white"
      >
        Contact Us
      </button>

      {/* Modal */}
      {isOpen && (
        <div className="fixed inset-0 flex items-center justify-center z-50 bg-black bg-opacity-50">
          <div className="bg-white w-11/12 sm:w-2/3 md:w-1/2 lg:w-1/3 p-6 rounded-lg shadow-lg">
            <div className="flex justify-between items-center border-b pb-4 mb-4">
              <h2 className="text-xl font-bold text-gray-800">Contact Us</h2>
              <button onClick={closeModal} className="text-gray-500 text-2xl hover:text-gray-800">
                &times;
              </button>
            </div>

            <div className="text-center">
              <img
                src="https://res.cloudinary.com/danm2mfq5/image/upload/v1736488959/xaqrkubomwowdvyqvxnv.png"
                alt="Contact Us Illustration"
                className="mx-auto mb-4"
              />
              <p className="text-gray-700 mb-4">
                Have questions? Feel free to reach out to us at:
              </p>
              <p className="text-gray-900 font-semibold">
                Email: advisors@theresumeadvisory.com
              </p>
              <p className="text-gray-900 font-semibold">
                Phone: 248.254.3822
              </p>
            </div>

          </div>
        </div>
      )}
    </>
  );
};

export default ContactModal;
